export class ErrorResponse {
    constructor(public message: string) {}
}